import type { Variants } from '@amplitude/experiment-js-client';

import type { FeatureFlags } from '@/types/FeatureFlags';

const TRUTHY_VALUES = new Set(['on', 'treatment']);

export const variantsToFeatureFlags = (variants: Variants): Record<string, boolean> =>
    Object.fromEntries(
        Object.entries(variants).map(([key, variant]) => [key, TRUTHY_VALUES.has(variant?.value ?? '')])
    );

/**
 * The feature flags every consumer sees, on the server and the client alike: the feature-flag API
 * payload with the Amplitude-derived flags on top. Both sides must call this with the same inputs,
 * or server and client render different trees and hydration fails.
 *
 * The base payload already includes the dev-tools cookie overrides, so for a key Amplitude also
 * defines, the Amplitude value wins over the cookie.
 */
export const mergeFeatureFlags = (baseFeatureFlags: FeatureFlags, variants: Variants): FeatureFlags => ({
    ...baseFeatureFlags,
    ...variantsToFeatureFlags(variants),
});
